import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Category boxes come ONLY from the POS feed categories (exact names, feed sort order). Colors/icons are decoration picked by keyword.
const PALETTE = ["#C9683A", "#9E3B3B", "#4F7F91", "#B9664C", "#C29A4B", "#7A5570", "#6B8E5A", "#5B6B9A", "#B99A4C", "#A3587E", "#C98373", "#9F5A72", "#4F8A80", "#8A8A55", "#A98735", "#7A6552"];
const ICON_RULES = [
  [/handi/i, "handi"], [/thali/i, "thali"], [/starter|chaat|snack|samosa/i, "samosa"], [/tandoor|grill|kebab|wing/i, "flame"],
  [/chicken/i, "drumstick"], [/goat|lamb|mutton|fish|shrimp/i, "bowl"], [/veg/i, "leaf"], [/biryani|rice|bowl/i, "biryani"],
  [/bread|naan|roti|paratha|pocket|burger/i, "naan"], [/combo|family|meal|pack|box/i, "box"], [/kid/i, "star"],
  [/lassi|drink|shake|beverage|chai/i, "glass"], [/dessert|sweet|kheer|jamun|mithai/i, "dessert"], [/side|chutney|condiment|sauce|raita/i, "jar"], [/fries/i, "flame"],
];
const iconFor = (name) => (ICON_RULES.find(([re]) => re.test(name || "")) || [null, "sparkle"])[1];
export const catSlug = (name) => (name || "").toLowerCase().replace(/&/g, " and ").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

// `categories` = Urban Turban feed categories then Urban Express feed categories, each already sorted by its feed sort_order.
export function groupProducts(entries, categories) {
  return categories.map((c, i) => {
    const items = entries.filter((e) => (e.product?.category_id ?? e.category_id) === c.id);
    return { key: catSlug(c.name), id: c.id, name: c.name, express: !!c.express, color: c.express ? "#6E6796" : PALETTE[i % PALETTE.length], icon: c.express ? "truck" : iconFor(c.name), items };
  }).filter((g) => g.items.length > 0);
}

const ICONS = {
  handi: "M12 3c-2 0-4 .6-5 1.5V7c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V4.5C16 3.6 14 3 12 3zM5 9.5C3.3 10.2 2.5 12 3 14c.6 3 4 7 9 7s8.4-4 9-7c.5-2-.3-3.8-2-4.5H5z",
  thali: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 3.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm0 3a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
  sparkle: "M12 2l2.2 6.6L21 11l-6.8 2.4L12 20l-2.2-6.6L3 11l6.8-2.4z",
  samosa: "M12 3l9.5 17h-19z",
  flame: "M12 2c1 4 5 5.5 5 10.5A5 5 0 017 12.5c0-2 1-3 1.5-4 .3 1.6 1.2 2.4 2 2.6C10 8 9.5 5 12 2z",
  drumstick: "M15.5 2.5a6 6 0 00-5.3 8.8l-5.9 5.9-1.2-.1-.9 1 .6.6-.6.6 1 .9-.1-1.2 5.9-5.9A6 6 0 1015.5 2.5z",
  bowl: "M3 10h18a9 9 0 01-18 0zm6-7a2 2 0 010 4M12 3a2 2 0 010 4M15 3a2 2 0 010 4",
  leaf: "M20 4c-8 0-14 4-15 12 4-1 7-4 9-8-2 5-5 8-10 10h3c7 0 12-5 13-14z",
  biryani: "M4 11h16v2a8 8 0 01-16 0v-2zm2-2a6 6 0 0112 0H6zm5-6h2v3h-2z",
  naan: "M12 3c5 0 9 3.5 9 8s-4 10-9 10-9-5.5-9-10 4-8 9-8zm-3 6a1.2 1.2 0 100 2.4A1.2 1.2 0 009 9zm6 1a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4zm-3 4a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z",
  box: "M3 7l9-4 9 4v10l-9 4-9-4zm9 4l9-4-9-4-9 4z",
  star: "M12 2l3 6.5 7 .9-5.2 4.8L18.2 21 12 17.4 5.8 21l1.4-6.8L2 9.4l7-.9z",
  dessert: "M7 9h10l-1.3 11a2 2 0 01-2 1.8H10.3a2 2 0 01-2-1.8zm5-7a4 4 0 014 4H8a4 4 0 014-4z",
  glass: "M6 2h12l-1.5 18a2 2 0 01-2 1.8h-5a2 2 0 01-2-1.8zm1.3 7h9.4l.4-5H6.9z",
  jar: "M8 2h8v3H8zm-2 4h12v13a3 3 0 01-3 3H9a3 3 0 01-3-3z",
  truck: "M2 6h12v9H2zm12 3h4l3 3v3h-7zM6 19.5a2 2 0 110-4 2 2 0 010 4zm11 0a2 2 0 110-4 2 2 0 010 4z",
};
const Icon = ({ name, color, size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"><path d={ICONS[name]} fill={color} /></svg>
);

const Scallops = ({ color, light }) => (
  <svg className="absolute left-0 right-0 top-0 w-full" height="10" preserveAspectRatio="none" viewBox="0 0 200 10" aria-hidden="true">
    <defs><pattern id={`sc-${color.slice(1)}${light ? "l" : ""}`} width="10" height="10" patternUnits="userSpaceOnUse"><circle cx="5" cy="0" r="5" fill={color} /></pattern></defs>
    <rect width="200" height="10" fill={`url(#sc-${color.slice(1)}${light ? "l" : ""})`} />
  </svg>
);

const MirrorDots = ({ color }) => (
  <div className="flex justify-center gap-1.5 mt-3" aria-hidden="true">
    {Array.from({ length: 7 }).map((_, i) => <span key={i} className="block w-2 h-2 rounded-full border" style={{ borderColor: color, background: "#fff", boxShadow: `inset 0 0 0 1.5px ${color}22` }} />)}
  </div>
);

export const scrollToSection = (key) => document.getElementById(`menu-section-${key}`)?.scrollIntoView({ behavior: "smooth", block: "start" });
let onPick = scrollToSection;
export const setBoxHandler = (fn) => { onPick = fn || scrollToSection; };

const BoxTile = ({ g }) => (
  <button type="button" onClick={() => onPick(g.key)} data-testid={`menu-box-${g.key}`}
    className="relative w-full h-full min-h-[132px] rounded-2xl pt-5 pb-3 px-3 text-center shadow-[0_2px_10px_rgba(62,39,35,0.06)] transition-transform hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#E8B33A]/60"
    style={{ background: "#FFFDF8", border: `2px solid ${g.color}`, fontFamily: "Poppins, sans-serif" }}>
    <Scallops color={g.color} />
    <div className="absolute inset-1.5 rounded-xl border pointer-events-none" style={{ borderColor: `${g.color}55` }} />
    {g.express && <span className="absolute top-3 right-3 text-[9px] font-extrabold tracking-[0.16em] px-1.5 py-0.5 rounded-sm" style={{ background: g.color, color: "#FBF6EC" }}>EXPRESS</span>}
    <div className="flex justify-center mt-1"><Icon name={g.icon} color={g.color} /></div>
    <p className="mt-2 font-bold leading-tight" style={{ color: "#3E2723", fontSize: 16 }}>{g.name}</p>
    <MirrorDots color={g.color} />
  </button>
);

const BuildTile = () => (
  <Link to="/build-your-meal" data-testid="menu-box-build-your-meal"
    className="relative w-full h-full min-h-[132px] rounded-2xl pt-5 pb-3 px-3 text-center shadow-[0_2px_10px_rgba(62,39,35,0.06)] transition-transform hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#E8B33A]/60 block"
    style={{ background: "#9E3B3B", border: "2px solid #9E3B3B", fontFamily: "Poppins, sans-serif" }}>
    <Scallops color="#E8B33A" />
    <div className="absolute inset-1.5 rounded-xl border pointer-events-none" style={{ borderColor: "#E8B33A88" }} />
    <span className="absolute top-3 right-3 text-[9px] font-extrabold tracking-[0.16em] px-1.5 py-0.5 rounded-sm" style={{ background: "#E8B33A", color: "#3E2723" }}>NEW</span>
    <div className="flex justify-center mt-1"><Icon name="thali" color="#FBF6EC" /></div>
    <p className="mt-2 font-bold leading-tight" style={{ color: "#FBF6EC", fontSize: 16 }}>Build your meal</p>
    <p className="text-[11px] mt-1" style={{ color: "#F3EBDD" }}>Thali · Bowl · Curry · Handi</p>
  </Link>
);

export function MenuSearch({ value, onChange }) {
  return (
    <div className="relative max-w-md mx-auto mb-6" style={{ fontFamily: "Poppins, sans-serif" }}>
      <input type="search" value={value} onChange={(e) => onChange(e.target.value)} placeholder="Search dishes — samosa, jeera, butter chicken…"
        aria-label="Search the menu" data-testid="menu-search-input"
        className="w-full rounded-full bg-white pl-5 pr-10 py-2.5 text-sm border-2 outline-none focus:ring-4 focus:ring-[#E8B33A]/40"
        style={{ borderColor: "#E8B33A", color: "#3E2723" }} />
      {value && <button type="button" onClick={() => onChange("")} aria-label="Clear search" data-testid="menu-search-clear"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-bold" style={{ color: "#9E3B3B" }}>✕</button>}
    </div>
  );
}

export function MenuCategoryBoxes({ groups, search, onSearch, buildLink = false }) {
  return (
    <section id="menu-category-boxes" className="rounded-2xl px-4 sm:px-6 pb-8 mb-10 scroll-mt-24" style={{ background: "#F3EBDD" }} data-testid="menu-category-boxes">
      <div className="text-center pt-8 mb-6">
        <h2 className="text-4xl sm:text-5xl" style={{ fontFamily: "'Yeseva One', serif", color: "#9E3B3B" }} data-testid="menu-heading">Menu</h2>
        <div className="flex items-center justify-center gap-2 mt-2" aria-hidden="true">
          <span className="block h-px w-10" style={{ background: "#E8B33A" }} /><span className="block w-2.5 h-2.5 rotate-45" style={{ background: "#E8B33A" }} /><span className="block h-px w-10" style={{ background: "#E8B33A" }} />
        </div>
      </div>
      {onSearch && <MenuSearch value={search} onChange={onSearch} />}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4" data-testid="menu-box-grid">
        {buildLink && <BuildTile />}
        {groups.map((g) => <BoxTile key={g.key} g={g} />)}
      </div>
    </section>
  );
}

export function MenuSections({ groups, renderCard }) {
  return groups.map((g) => (
    <section key={g.key} id={`menu-section-${g.key}`} className="scroll-mt-24 mb-12" data-testid={`menu-section-${g.key}`}>
      <div className="flex items-center gap-3 mb-4">
        <Icon name={g.icon} color={g.color} size={22} />
        <h2 className="text-xl sm:text-2xl font-extrabold" style={{ fontFamily: "Poppins, sans-serif", color: "#3E2723" }}>{g.name}</h2>
        <span className="flex-1 h-[3px] rounded-full" style={{ background: g.color }} aria-hidden="true" />
        <span className="text-xs font-semibold text-neutral-500">{g.items.length} {g.items.length === 1 ? "dish" : "dishes"}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">{g.items.map(renderCard)}</div>
    </section>
  ));
}

export function CategoriesFab() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => { const el = document.getElementById("menu-category-boxes"); setShow(!!el && el.getBoundingClientRect().bottom < 0); };
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button type="button" onClick={() => document.getElementById("menu-category-boxes")?.scrollIntoView({ behavior: "smooth", block: "start" })}
      data-testid="menu-categories-fab"
      className="fixed bottom-20 sm:bottom-6 left-1/2 -translate-x-1/2 z-30 px-4 py-2 rounded-full text-sm font-bold text-white shadow-lg"
      style={{ background: "#C62828", fontFamily: "Poppins, sans-serif" }}>
      Categories
    </button>
  );
}

// ---- Boxes-only menu: one category at a time (?cat=slug) ----
export function MenuCategoryView({ group, onBack, renderCard }) {
  return (
    <section id={`menu-section-${group.key}`} className="mb-12" data-testid={`menu-section-${group.key}`}>
      <button type="button" onClick={onBack} data-testid="menu-back-button"
        className="inline-flex items-center gap-2 text-sm font-bold mb-5 px-4 py-2 rounded-full bg-white border hover:bg-[#FBF6EC] transition-colors"
        style={{ borderColor: "#E8B33A", color: "#3E2723", fontFamily: "Poppins, sans-serif" }}>
        ← Back to menu
      </button>
      <div className="flex items-center gap-3 mb-5">
        <Icon name={group.icon} color={group.color} size={24} />
        <h2 className="text-2xl sm:text-3xl font-extrabold" style={{ fontFamily: "Poppins, sans-serif", color: "#3E2723" }}>{group.name}</h2>
        <span className="flex-1 h-[3px] rounded-full" style={{ background: group.color }} aria-hidden="true" />
        <span className="text-xs font-semibold text-neutral-500">{group.items.length} {group.items.length === 1 ? "dish" : "dishes"}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">{group.items.map(renderCard)}</div>
    </section>
  );
}

export function MenuSearchResults({ query, entries, onClear, renderCard }) {
  return (
    <section className="mb-12" data-testid="menu-search-results" style={{ fontFamily: "Poppins, sans-serif" }}>
      <div className="flex items-center gap-3 mb-5">
        <h2 className="text-xl sm:text-2xl font-extrabold" style={{ color: "#3E2723" }}>Results for “{query}”</h2>
        <span className="flex-1 h-[3px] rounded-full" style={{ background: "#E8B33A" }} aria-hidden="true" />
        <span className="text-xs font-semibold text-neutral-500" data-testid="menu-search-count">{entries.length} {entries.length === 1 ? "match" : "matches"}</span>
      </div>
      {entries.length === 0 ? (
        <p className="text-center text-neutral-500 py-10" data-testid="menu-search-empty">Nothing matched — try another word or <button type="button" onClick={onClear} className="underline font-bold" style={{ color: "#9E3B3B" }}>browse the menu</button>.</p>
      ) : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">{entries.map(renderCard)}</div>}
    </section>
  );
}

export function ThisWeekStrip({ cards, onSelect, showBogo }) {
  if (!cards.length && !showBogo) return null;
  const money = (n) => `$${Number(n).toFixed(2)}`;
  return (
    <section className="mb-8" data-testid="this-week-strip" style={{ fontFamily: "Poppins, sans-serif" }}>
      <div className="flex items-center gap-3 mb-3">
        <h2 className="text-xl sm:text-2xl" style={{ fontFamily: "'Yeseva One', serif", color: "#9E3B3B" }}>This Week</h2>
        <span className="flex-1 h-px" style={{ background: "#E8B33A" }} aria-hidden="true" />
      </div>
      <div className={`grid grid-cols-1 sm:grid-cols-2 ${showBogo ? "lg:grid-cols-4" : "sm:grid-cols-3"} gap-3 sm:gap-4`}>
        {showBogo && (
          <a href="#bogo" data-testid="this-week-bogo-card"
            className="flex items-center gap-3 rounded-2xl p-3 text-left border shadow-[0_2px_10px_rgba(62,39,35,0.06)] hover:-translate-y-0.5 transition-transform"
            style={{ background: "linear-gradient(135deg, #171007, #3B2A10)", borderColor: "#E8B33A" }}>
            <span className="w-16 h-16 rounded-xl shrink-0 flex items-center justify-center text-2xl font-extrabold" style={{ background: "rgba(232,179,58,0.15)", color: "#F3D27A" }} aria-hidden="true">2×</span>
            <span className="min-w-0">
              <span className="block text-[10px] font-bold tracking-[0.18em]" style={{ color: "#C9A95C" }}>LIMITED TIME</span>
              <span className="block font-bold text-sm leading-tight" style={{ color: "#F3D27A" }}>BOGO: Buy One, Get One Free</span>
              <span className="block text-xs mt-0.5 underline" style={{ color: "#E8B33A" }}>See the dishes</span>
            </span>
          </a>
        )}
        {cards.slice(0, 3).map((p) => (
          <button type="button" key={p.id} onClick={() => onSelect(p)} data-testid={`this-week-card-${p.id}`}
            className="flex items-center gap-3 rounded-2xl p-3 text-left border shadow-[0_2px_10px_rgba(62,39,35,0.06)] hover:-translate-y-0.5 transition-transform" style={{ background: "#FFFDF8", borderColor: "#E8B33A66" }}>
            {p.image ? <img src={p.image} alt="" width="64" height="64" className="w-16 h-16 rounded-xl object-cover shrink-0" loading="lazy" />
              : <span className="w-16 h-16 rounded-xl shrink-0" style={{ background: "#F3EBDD" }} aria-hidden="true" />}
            <span className="min-w-0">
              <span className="block text-[10px] font-bold tracking-[0.18em]" style={{ color: "#B8860B" }}>{p.type === "combo" ? "WEEKLY COMBO" : "SPECIAL"}</span>
              <span className="block font-bold text-sm leading-tight truncate" style={{ color: "#3E2723" }}>{p.name}</span>
              <span className="block text-sm mt-0.5"><span className="font-bold" style={{ color: "#C62828" }}>{money(p.display_price)}</span>
                {p.on_sale && p.regular_price > p.display_price && <s className="ml-2 text-neutral-400 text-xs">{money(p.regular_price)}</s>}</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}

export function OurStoryTeaser({ story, image }) {
  return (
    <section className="mt-14 mb-6 rounded-3xl px-6 sm:px-10 py-10 grid md:grid-cols-5 gap-8 items-center" style={{ background: "#F3EBDD", fontFamily: "Poppins, sans-serif" }} data-testid="store-our-story">
      {image && <img src={image} alt="Urban Turban by VeerGi" width="480" height="360" className="md:col-span-2 w-full aspect-[4/3] object-cover rounded-2xl" loading="lazy" />}
      <div className={image ? "md:col-span-3" : "md:col-span-5"}>
        <h2 className="text-3xl sm:text-4xl" style={{ fontFamily: "'Yeseva One', serif", color: "#9E3B3B" }}>{story.h1}</h2>
        <p className="mt-4 text-base leading-relaxed" style={{ color: "#3E2723" }}>{story.paragraphs[0]}</p>
        <p className="mt-3 text-base leading-relaxed" style={{ color: "#3E2723" }}>{story.paragraphs[story.paragraphs.length - 1]} <span className="font-semibold">{story.signature}</span></p>
        <a href="/our-story" data-testid="store-our-story-link" className="inline-flex mt-5 px-5 py-2.5 rounded-full text-sm font-bold text-white" style={{ background: "#9E3B3B" }}>Read more</a>
      </div>
    </section>
  );
}
